<template>
  <b-overlay :show="loading">
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-alert v-if="error" show variant="danger" class="mt-2">
            System error - contact tech support.
            <!-- TBD error component. -->
          </b-alert>

          <div class="div-section-header">
            <b-row>
              <b-col cols="12">
                <div>
                  <span class="txt-section-title">{{title}}</span>
                </div>
              </b-col>
              <b-col v-if="rows !== 0" cols="12">
                  <span class="txt-section-subtitle red">Classes: {{totalRows}}</span>
              </b-col>
            </b-row>
          </div>

          <b-card v-if="rows === 0">
            <h5>No viewed tutorials.</h5>
            <p>Click the button below to proceed to Product Training</p>
            <b-button to="/tutorials">Product Training</b-button>
          </b-card>

          <!-- TBD classList component. -->
          <div v-if="rows !== 0" class="div-section-body">

            <div v-for="(row,ix) in classes" v-bind:key="row.classId">
              <div v-if="showMobileAd(ix)">
                <mobilead :mb="getMobileAd(ix)"></mobilead>
              </div>
              <b-row class="mt-3 pointer" @click.prevent="gotoClass(row.hash)">
                <b-col cols="4">
                  <!-- {{row.classId}} -->
                    <b-img fluid v-bind:src="row.photo" />
                </b-col>
                <b-col cols="8" style="margin-left: -20px;">
                  <div class="class-title">{{row.className}}</div>
                  <div class="class-details">
                    {{row.sponsorCompanyName}}
                    <br>{{row.releaseDate | prettyDate}}
                  </div>
                </b-col>
              </b-row>
            </div>

            <b-row v-if="pages > 1" class="mt-3">
              <b-col>
                <b-pagination align="center" v-model="curPage" :total-rows="totalRows" :per-page="pageSize" @change="pageChange" @input="pageInput"></b-pagination>
              </b-col>
            </b-row>

          </div>
        </b-col>
      </b-row>

    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */

import service from "@/service/service";
import utils from "@/utils/utils";

export default {
  name: "Queue",
  data() {
    return {
      debug: false,
      error: false,
      loading: true,
      studentHash: this.$root.getToken(),
      title: "Viewed Tutorials",
      blurb: "",
      classes: [],
      mobileAds: null,
      adIndexArr: [],  // indexer into mobileAds.banners[]
      totalRows: 0,
      pageSize: 0,
      pages: 0,
      curPage: 1,
      bannerAds: []
    }
  },
  props: {
    page: {
      type:String,
      required: false,
      default: "1"
    }
  },
  computed: {
    rows () {
      return this.classes.length
    }
  },
  methods: {
    pageInput(page) {
      // console.log(`pageInput: ${page}`)
    },
    pageChange(page) {
      this.curPage = page
      this.doTutorialHistory()
      // console.log(`pageChange: ${page}`)
    },
    linkGen(pageNum) {
      return pageNum === 1 ? '/tutorial-history' : `/tutorial-history/${pageNum-1}`
    },
    setCurPage() {
      try {
        this.curPage = parseInt(this.page)
        if (this.curPage <= 0) this.curPage = 1
      }
      catch(e) {
        this.curPage = 1
      }
      // console.log( `this.page: ${this.page}  curPage: ${this.curPage}`)
    },
    gotoClass(hash) {
      this.$router.push(`/classroom/${hash}`)
    },
    showMobileAd(ix) { // returns boolean indicating whether slot has mobile ad
      return this.adIndexArr[ix] !== -1
    },
    getMobileAd(ix) {
      let aout = {adId: 0, adUrls: []}
      if (this.adIndexArr[ix] != -1) {
        aout = this.mobileAds.banners[this.adIndexArr[ix]]
      }
      return aout
    },
    doTutorialHistory() {
      this.loading = true
      this.classes = []
      service
        .getTutorialHistory(this.studentHash, this.curPage-1)
        .then(res => {
          if (this.debug) console.log(res)
          if (res.status && res.rowCount !== 0) {
            this.blurb = `Queue: ${res.rowCount}`
            this.classes = res.data
            this.totalRows = res.totalRows
            this.pageSize = res.pageSize
            this.pages = (res.pageSize) ? Math.ceil( this.totalRows/res.pageSize ): 0
            if (this.curPage > this.pages) this.curPage = this.pages

            this.mobileAds = (res.mobileAds) ? res.mobileAds : {indexStart:0, interval: 0, rows: 0, banners: []}
            this.adIndexArr = utils.getAdIndexArray( this.classes.length, this.mobileAds.banners.length, this.mobileAds.indexStart, this.mobileAds.interval )
          } else {
            this.blurb = "No viewed tutorials."
          }
        })
        .finally(() => this.loading = false)
        .catch(e => console.log(e));
    }
  },
  created() {
    this.doTutorialHistory()
  },
  mounted() {
    // console.log('mounted')
  },
  beforeDestroy() {
    // console.log('destroy')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/TutorialHistory.vue